<template>
    <div>
        <loading-custom :loading="loading" />
        <form @submit.prevent="handleSubmit()">
            <div class="body">
                <div class="media">
                    <div class="media-left m-r-20" v-if="imageSrc">
                        <img
                            ref="shop_image"
                            @error="imageError(`shop_image`)"
                            :src="imageSrc"
                            class="user-photo media-object"
                            alt="User"
                        />
                    </div>
                    <div class="media-body">
                        <p>เพิ่มรูปภาพร้านค้า</p>
                        <button
                            type="button"
                            class="btn btn-default"
                            id="btn-upload-photo"
                            @click="uploadImage"
                        >
                            อัพโหลด
                        </button>
                        <input
                            type="file"
                            id="filePhoto"
                            @change="onFileChange"
                            class="sr-only"
                        />
                    </div>
                </div>
            </div>
            <div class="body">
                <div class="row clearfix">
                    <div class="col-lg-5 col-md-10">
                        <div class="form-group">
                            <label class="tw-ml-2">ชื่อร้านค้า</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="ชื่อร้านค้า"
                                v-model="form.name"
                                required
                            />
                        </div>
                    </div>
                    <div class="col-lg-3 col-4">
                        <div class="form-group">
                            <label class="tw-ml-2">อีเมล</label>
                            <input
                                type="email"
                                class="form-control"
                                placeholder="อีเมล"
                                v-model="form.email"
                            />
                        </div>
                    </div>
                    <div class="col-lg-2 col-4">
                        <div class="form-group">
                            <label class="tw-ml-2">เบอร์โทรศัพท์</label>
                            <input
                                class="form-control"
                                pattern="^(0[14689][0-9]{8}|02[0-9]{7})"
                                maxlength="10"
                                type="text"
                                placeholder="เบอร์โทรศัพท์"
                                v-model="form.phone"
                            />
                        </div>
                    </div>
                    <div class="col-lg-2 col-4">
                        <div class="form-group">
                            <label class="tw-ml-2">สกุลเงิน</label>
                            <select
                                class="form-control"
                                placeholder="กรุณาเลือกสกุลเงิน"
                                v-model="form.currency"

                            >   
                                <option value="" disabled>
                                    กรุณาเลือกสกุลเงิน
                                </option>
                                <option v-for="(currency, index) in currencies" :key="index" :value="currency.name">
                                    {{ currency ? currency.name : '' }} ({{ currency ? currency.symbol : '' }})
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <div class="form-group">
                            <label class="tw-ml-2">ที่อยู่</label>
                            <textarea
                                class="form-control"
                                rows="5"
                                cols="30"
                                maxlength="200"
                                placeholder="ที่อยู่"
                                v-model="form.address"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body">
                <div class="tw-w-full text-right">
                    <button class="btn btn-sm btn-success">
                        บันทึก
                    </button>
                    &nbsp;&nbsp;
                    <button
                        type="button"
                        class="btn btn-sm btn-default"
                        @click="back()"
                    >
                        ย้อนกลับ
                    </button>
                </div>
            </div>
        </form>
    </div>
    
</template>
<script>
export default {
    props: {
        shop: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            imageSrc: "",
            form: "",
            image: null,
            default_img: "/images/no_pictures.png",
            loading: false,
            currencies: null,
        };
    },
    mounted() {
        this.setData();
        this.getCurrencies();
    },
    methods: {
        imageError(id) {
            this.$refs[id][0].setAttribute("src", this.default_img);
        },
        setData() {
            this.imageSrc = this.shop.shop_detail.image_url || "";
            this.form = {
                name: this.shop.name,
                email: this.shop.shop_detail?.email || "",
                phone: this.shop.shop_detail?.phone || "",
                address: this.shop.shop_detail?.address || "",
                currency: this.shop.shop_detail?.currency || ""
            };
        },
        handleSubmit() {
            this.updateShop();
        },
        async updateShop() {
            this.loading = true;
            let formData = new FormData();
            Object.keys(this.form).forEach(element => {
                formData.append(element, this.form[element]);
            });
            formData.append("image", this.image ? this.image : "");
            formData.append("_method", "PATCH");

            await axios
                .post(
                    `/backend/s/${this.shop.reference}/setting/${this.shop.id}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                )
                .then(res => {
                    this.loading = false;
                    window.location.href = `/backend/s/${this.shop.reference}/setting`;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        "ไม่สามารถทำรายการได้กรุณาลองใหม่อีกครั้ง"
                    );
                });
        },
        async getCurrencies() {
            this.loading = true;
            await axios
                .get(`/ajax/frontend/s/${this.shop}/currencies`)
                .then(res => {
                    this.currencies = res.data.currencies;
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        back() {
            window.location.href = `/backend/s/${this.shop}/setting`;
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        uploadImage() {
            document.getElementById("filePhoto").click();
        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            const file_size = files[0].size / 1024 / 1024;
            const file_name = files[0].name;
            const re = /(\.jpg|\.jpeg|\.png)$/i;
            if (file_size > 2) {
                this.messageAlert(
                    "error",
                    "ขนาดภาพใหญ่ไปนะ",
                    "TwT ขอโทษนะ กรุณาใช้ภาพขนาดไม่เกิน 2mb",
                    1500
                );
            } else if (!re.exec(file_name)) {
                this.messageAlert(
                    "error",
                    "ไฟล์นี้ใช้ไม่ได้นะ",
                    "TwT ขอโทษนะ กรุณาใช้รูปภาพประเภท jpg, jpeg, png",
                    1500
                );
            } else {
                this.image = files[0];
                this.previewImage(files[0]);
            }
        },
        previewImage(file) {
            this.imageSrc = URL.createObjectURL(file);
        }
    }
};
</script>
<style lang="scss" scoped>
.media {
    @media (min-width: 0px) and (max-width: 992px) {
        width: 100%;
        flex-flow: column;
        flex-direction: column-reverse;
    }
}
.media-left {
    img {
        width: 100%;
        max-width: 200px;
    }
    @media (min-width: 0px) and (max-width: 992px) {
        margin-top: 20px;
    }
}
</style>
